// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__2Rh_f","main":"App_main__3ZkGI","mainTop":"App_mainTop__1XzKp","mainCenter":"App_mainCenter__1FTY0","content":"App_content__3La4L"};